export default [{
  path: '/dict',
  name: 'dict',
  component: resolve => require(['@/views/setting/dict/dict.vue'], resolve),
  meta: {
    group: "/dict",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, {
  path: '/dict/dictType/:dictType',
  name: 'dictType',
  component: resolve => require(['@/views/setting/dict/dictType.vue'], resolve),
  meta: {
    group: "/dict",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/dict/dict.js